
import Component, { mixins } from 'vue-class-component'
import NewsMixin from './news-mixin/index'
import NewsItem from '@/components/news-item/index.vue'
import ItemTitle from '@/components/item-title/index.vue'
import { Prop, Vue, Watch } from 'vue-property-decorator'
import { NewsMixinManager } from './news-mixin/manager'
import { NewsMixinService } from './news-mixin/service'
@Component({
  components: {
    ItemTitle,
    NewsItem
  }
})

export default class extends Vue {
  @Prop() id!: string

  private manager = new NewsMixinManager(0, '', new NewsMixinService())
  @Watch('id')
  onmenuIdchange (val: any): void {
    if (!val) {
      return
    }
    this.manager.getNewsInfomation(this.id)
  }

  get conten () {
    return this.manager.series.slice(0, 5)
  }

  mounted () {
    this.manager.getNewsInfomation(this.id)
    console.log(this.manager.series.slice(0, 5))
  }

  showDetail (info: any) {
    window.location.href = (`/infoNews.html#/news/${info.id}/${'0'}`)
  }

  seeMore () {
    window.location.href = (`/news.html#/${this.id}`)
  }
}
